<template>
  <template v-for="menu in menus" :key="menu.index">
    <template v-if="menu.children">
      <el-sub-menu :index="menu.index">
        <template #title>
          {{ menu.title }}
        </template>
        <menu-item :menus="menu.children" />
      </el-sub-menu>
    </template>
    <template v-else>
      <el-menu-item :index="menu.index">{{ menu.title }}</el-menu-item>
    </template>
  </template>
</template>

<script setup>
  import { defineProps } from 'vue'

  defineProps({
    menus: {
      type: Array,
      default: () => []
    }
  })
</script>

<style lang="scss" scoped></style>
